import { render, staticRenderFns } from "./MessageSend.vue?vue&type=template&id=edb97f0e&scoped=true&"
import script from "./MessageSend.vue?vue&type=script&lang=js&"
export * from "./MessageSend.vue?vue&type=script&lang=js&"
import style0 from "./MessageSend.vue?vue&type=style&index=0&id=edb97f0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb97f0e",
  null
  
)

export default component.exports